import React, { Component, Fragment } from 'react';
import { Button, Container, Row, Col, Form, Jumbotron, Table } from 'react-bootstrap';
import config from '../../../config';

import SearchItem from '../../subcomponent/searchItem';
import errores from '../../../middleware/errordb'
import { CSVLink } from "react-csv";
import Modaldoc from '../../subcomponent/modalDocument';

export class reporteMovimiento extends Component {
    constructor(props) {
        super(props);
        const currentCompany = sessionStorage.getItem('company');
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
        const yyyy = today.getFullYear();
        const todayFormat = yyyy + "-" + mm + "-" + dd;

        this.state = {
            empresa: currentCompany,
            fecha_inicial: todayFormat,
            fecha_final: todayFormat,
            bodega: "",
            tipo_inv: "",
            cat_inv: "",
            linea_inv: "",
            item: "",
            list_items: [],
            list_bodegas: [],
            list_tipo: [],
            list_categorias: [],
            list_lineas: [],
            currentItem: [],
            infoReporte: []
        }

    }

    componentDidMount() {
        const datasend = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'tipo': this.state.tipo,
            }
        }
        fetch(config.servBackEnd + '/reports/inventory', datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    const datos = data.data;
                    this.setState({
                        list_items: datos[0],
                        list_bodegas: datos[1],
                        list_tipo: datos[2],
                        list_categorias: datos[3],
                        list_lineas: datos[4]
                    });
                } else {
                    this.setState({ mostrarMensaje: true, mensaje: data.message })
                }
            });
    }

    initReporte = () => {
        const { empresa } = this.state;
        const { bodega } = this.state;
        const { item, tipo_inv, cat_inv, linea_inv } = this.state;
        const { fecha_inicial } = this.state;
        const { fecha_final } = this.state;

        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                empresa,
                bodega,
                item,
                fecha_inicial,
                fecha_final,
                tipo_inv,
                cat_inv,
                linea_inv
            }),
            headers: {
                'Content-Type': 'application/json',
                'tipo': this.state.tipo,
                'empresa': empresa
            }
        };
        fetch(config.servBackEnd + '/reports/inventorymovement', datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    this.setState({ infoReporte: data.data });
                } else {
                    this.setState({ infoReporte: [], mostrarMensaje: true, mensaje: "Ingreso con errores:" + errores[data.code] + " " + data.message })
                }
            });
    }

    addItem = (selectItem) => {
        this.setState({
            currentItem: selectItem,
            item: selectItem.ID_ITEMS,
            infoReporte: []
        });
    }

    limpiarForm = () => {
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
        const yyyy = today.getFullYear();
        const todayFormat = yyyy + "-" + mm + "-" + dd;

        this.setState({
            fecha_inicial: todayFormat,
            fecha_final: todayFormat,
            bodega: "",
            tipo_inv: "",
            cat_inv: "",
            linea_inv: "",
            item: "",
            currentItem: [],
            infoReporte: []
        });
    }

    handleShow = () => {
        this.state({ show: true });
    }

    filterItems = (data) => {
        const tmpData = [];
        const { tipo_inv, cat_inv, linea_inv } = this.state;
        data.forEach(element => {
            if (
                ((element.GRUPO_ITEM || "").toString() === cat_inv.toString() || cat_inv.toString() === "") &&
                ((element.LINEA_ITEM || "").toString() === linea_inv.toString() || linea_inv.toString() === "") &&
                ((element.TIPO_ITEM || "").toString() === tipo_inv.toString() || tipo_inv.toString() === "")
            ) {
                tmpData.push(element);
            }
        });
        return tmpData;
    }
    render() {
        const { list_bodegas, list_tipo, list_categorias, list_lineas } = this.state;
        const { currentItem, tipo_inv, cat_inv } = this.state;
        const { infoReporte } = this.state;
        const tmpItems = this.filterItems(this.state.list_items);
        let acumulado = 0;
        let totalCosto = 0;
        return (
            <Fragment>

                <Jumbotron className="Jumbotron">
                    <h2>Reporte de movimientos</h2>
                </Jumbotron>
                <Container fluid>
                    <Row className="justify-content-md-center" >
                        <Col className="mb-2" xs={5} lg={1}>FECHA INICIO</Col>
                        <Col className="mb-2" xs={7} lg={2}>
                            <Form.Control type="date" onChange={e => this.setState({ fecha_inicial: e.target.value, infoReporte: [] })} value={this.state.fecha_inicial} />
                        </Col>
                        <Col className="mb-2" xs={5} lg={1}>FECHA FIN</Col>
                        <Col className="mb-2" xs={7} lg={2}>
                            <Form.Control type="date" onChange={e => this.setState({ fecha_final: e.target.value, infoReporte: [] })} value={this.state.fecha_final} />
                        </Col>
                        <Col className="mb-2" xs={5} lg={1}>Seleccione Bodega</Col>
                        <Col className="mb-2" xs={7} lg={2}>
                            <Form.Control as="select" onChange={e => this.setState({ bodega: e.target.value, infoReporte: [] })} value={this.state.bodega} required >
                                <option value="">Seleccione</option>
                                {
                                    list_bodegas.map((bodega, i) => {
                                        return (<option key={'b' + i} value={bodega.ID_BODEGAS}>{bodega.DESCRIPCION_BODEGA}</option>)
                                    })
                                }
                            </Form.Control>
                        </Col>
                        <Col className="mb-2" xs={5} lg={1}>Tipo Inventario</Col>
                        <Col className="mb-2" xs={7} lg={2}>
                            <Form.Control as="select" onChange={e => this.setState({ tipo_inv: e.target.value, infoReporte: [], linea_inv: "", cat_inv: "" })} value={this.state.tipo_inv} required >
                                <option value="">Seleccione</option>
                                {
                                    list_tipo.map((tipo, i) => {
                                        return (<option key={'t' + i} value={tipo.ID_TIPO_INVENTARIO}>{tipo.DESCRIPCION_TIPO_INV}</option>)
                                    })
                                }
                            </Form.Control>
                        </Col>
                        <Col className="mb-2" xs={5} lg={1}>Grupo Inventario</Col>
                        <Col className="mb-2" xs={7} lg={2}>
                            <Form.Control as="select" onChange={e => this.setState({ cat_inv: e.target.value, infoReporte: [], linea_inv: "" })} value={this.state.cat_inv} required >
                                <option value="">Seleccione</option>
                                {
                                    list_categorias.map((tipo, i) => {
                                        if ((tipo.ID_TIPO_INVENTARIO || "").toString() === tipo_inv.toString() || tipo_inv.toString() === "") {
                                            return (<option key={'c' + i} value={tipo.ID_GRUPO_INVENTARIO}>{tipo.DESCRIPCION_GRUPO_INV}</option>)
                                        } else {
                                            return null;
                                        }
                                    })
                                }
                            </Form.Control>
                        </Col>
                        <Col className="mb-2" xs={5} lg={1}>Linea Inventario</Col>
                        <Col className="mb-2" xs={7} lg={2}>
                            <Form.Control as="select" onChange={e => this.setState({ linea_inv: e.target.value, infoReporte: [] })} value={this.state.linea_inv} required >
                                <option value="">Seleccione</option>
                                {
                                    list_lineas.map((linea, i) => {
                                        if (((linea.ID_TIPO_INVENTARIO || "").toString() === tipo_inv.toString() || tipo_inv.toString() === "") &&
                                            ((linea.ID_GRUPO_INVENTARIO || "").toString() === cat_inv.toString() || cat_inv.toString() === "")
                                        ) {
                                            return (<option key={'l' + i} value={linea.ID_LINEA_INVENTARIO}>{linea.DESCRIPCION_LINEA_INV}</option>)
                                        } else {
                                            return null;
                                        }
                                    })
                                }
                            </Form.Control>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <SearchItem data={tmpItems} event={this.addItem} clean={true} ></SearchItem>
                        </Col>
                        <Col>
                            <Form.Group controlId="exampleForm.ControlInput1">
                                <Form.Label>Item Seleccionado</Form.Label>
                                <Form.Control type="text" value={(currentItem.REFERENCIA_ITEM || "-") + " - " + (currentItem.DESCRIPCION_ITEM || "-")} plaintext readOnly />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Button onClick={this.limpiarForm} >Limpiar</Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button disabled={this.state.bodega === ""} onClick={this.initReporte} className="m-3" name="actualizar" >Generar Reporte</Button>
                            <CSVLink data={infoReporte} filename={"reporteMovimiento.csv"} separator={";"}>
                                <Button disabled={infoReporte.length === 0} variant="success">Descargar Reporte</Button>
                            </CSVLink>
                            {/* <Button disabled={this.state.tipo_reporte === ""} onClick={this.initReporte} className="m-3" name="descargar" ></Button> */}
                        </Col>
                    </Row>
                </Container>
                <Container>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <td>FECHA</td>
                                <td>DOCUMENTO</td>
                                <td>BODEGA</td>
                                <td>REFERENCIA</td>
                                <td>DESCRIPCION</td>
                                <td>CANTIDAD</td>
                                {currentItem.REFERENCIA_ITEM && <td>SALDO DE INVENTARIO</td>}
                                <td>COSTO</td>
                            </tr>
                        </thead>
                        <tbody>
                            {infoReporte.length > 0 &&
                                infoReporte.map((element, i) => {
                                    acumulado += parseFloat(element.CANTIDAD);
                                    totalCosto += parseFloat((element.COSTO || 0));
                                    return (<tr key={'tr' + i}>
                                        <td><Modaldoc text={element.FECHA_CORTA} item={element.DESCRIPCION_ITEM} cantidad={element.CANTIDAD} costo={element.COSTO} fecha={element.FECHA_CORTA} document={element.TIPO_MOVIMIENTO + "-" + element.NUMERO_DOCUMENTO} des_bodega={element.DESCRIPCION_BODEGA}></Modaldoc></td>
                                        <td> <Modaldoc text={element.TIPO_MOVIMIENTO + "-" + element.NUMERO_DOCUMENTO} item={element.DESCRIPCION_ITEM} cantidad={element.CANTIDAD} costo={element.COSTO} fecha={element.FECHA_CORTA} document={element.TIPO_MOVIMIENTO + "-" + element.NUMERO_DOCUMENTO} des_bodega={element.DESCRIPCION_BODEGA} /> </td>
                                        <td><Modaldoc text={element.TIPO_MOVIMIENTO + "-" + element.NUMERO_DOCUMENTO} item={element.DESCRIPCION_ITEM} cantidad={element.CANTIDAD} costo={element.COSTO} fecha={element.FECHA_CORTA} document={element.TIPO_MOVIMIENTO + "-" + element.NUMERO_DOCUMENTO} des_bodega={element.DESCRIPCION_BODEGA} /> </td>
                                        <td><Modaldoc text={element.DESCRIPCION_BODEGA} item={element.DESCRIPCION_ITEM} cantidad={element.CANTIDAD} costo={element.COSTO} fecha={element.FECHA_CORTA} document={element.TIPO_MOVIMIENTO + "-" + element.NUMERO_DOCUMENTO} des_bodega={element.DESCRIPCION_BODEGA}></Modaldoc></td>
                                        <td><Modaldoc text={element.REFERENCIA_ITEM} item={element.DESCRIPCION_ITEM} cantidad={element.CANTIDAD} costo={element.COSTO} fecha={element.FECHA_CORTA} document={element.TIPO_MOVIMIENTO + "-" + element.NUMERO_DOCUMENTO} des_bodega={element.DESCRIPCION_BODEGA}></Modaldoc></td>
                                        <td><Modaldoc text={element.DESCRIPCION_ITEM} item={element.DESCRIPCION_ITEM} cantidad={element.CANTIDAD} costo={element.COSTO} fecha={element.FECHA_CORTA} document={element.TIPO_MOVIMIENTO + "-" + element.NUMERO_DOCUMENTO} des_bodega={element.DESCRIPCION_BODEGA}></Modaldoc></td>
                                        <td><Modaldoc text={element.CANTIDAD} item={element.DESCRIPCION_ITEM} cantidad={element.CANTIDAD} costo={element.COSTO} fecha={element.FECHA_CORTA} document={element.TIPO_MOVIMIENTO + "-" + element.NUMERO_DOCUMENTO} des_bodega={element.DESCRIPCION_BODEGA}></Modaldoc></td>
                                        {currentItem.REFERENCIA_ITEM && <td>{acumulado}</td>}
                                        <td className="currSign">{Intl.NumberFormat('es-MX').format(element.COSTO)}</td>
                                        <td className="currSign"><Modaldoc text={Intl.NumberFormat('es-MX').format(element.COSTO)} item={element.DESCRIPCION_ITEM} cantidad={element.CANTIDAD} costo={element.COSTO} fecha={element.FECHA_CORTA} document={element.TIPO_MOVIMIENTO + "-" + element.NUMERO_DOCUMENTO} des_bodega={element.DESCRIPCION_BODEGA} /></td>
                                    </tr>);
                                })
                            }
                            {
                                infoReporte.length === 0 &&
                                <tr>
                                    <td colSpan={(currentItem.REFERENCIA_ITEM) ? "8" : "7"}> Consulta sin resultado </td>
                                </tr>
                            }
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan={(currentItem.REFERENCIA_ITEM) ? "6" : "5"}></td>
                                <td>COSTO TOTAL</td>
                                <td className="currSign" >{Intl.NumberFormat('es-MX').format(totalCosto)}</td>
                            </tr>
                        </tfoot>
                    </Table>
                </Container>
            </Fragment >
        )
    }
}

export default reporteMovimiento



// WEBPACK FOOTER //
// ./src/components/bussines/inventarios/reporteMovimiento.jsx